import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/constants/clinic";

export const Faq = () => (
  <section id="faq" className="py-20 lg:py-28 bg-white">
    <div className="max-w-3xl mx-auto px-6">
      <p className="text-sm font-semibold uppercase tracking-widest text-secondary">FAQs</p>
      <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#1A252C]">Before your visit</h2>
      <Accordion type="single" collapsible className="mt-10">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`f${i}`}>
            <AccordionTrigger className="text-left text-base font-medium" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
